module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HOPKINS IN WALES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Wednesday, December 8th, 1875. A soft confetti of snow-flakes was fluttering down upon Wales. The higher windowpanes were gardens of frost. His right hand still twined a rosary, its anesthetic routine of prayers his nightly defense against sleeplessness. Lying in bed in his nightshirt and black woolen stockings, Hopkins recited his Morning Offering, then stood to use the chamber pot. The scuttle contained only a scarcity of coals and he would want those for his studies, so he gashed the fireplace embers with an iron poker and held his hands over their golden, waning heat. He lit and chimneyed one gas retort on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Washing with Castile soap and icy water, he worried over his scrawniness, his spindle shins, the green yarns of vein in his forearms, his face so thin that his zygomatic bones and jaw shaped harps underneath his ginger-brown, one-inch beard and mustache. His high school nickname was Skin, and even now at age thirty-one he weighed hardly a hundred pounds, with a jockey’s height of five foot four. “Eats like a parakeet,” Cyprian Splaine had said just last night, and Rickaby joked, “Eats like a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("single")]), _vm._v(" keet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yesterday’s long underwear would do, Hopkins thought, and then a jersey that the Jesuit Theologate’s laundress had shrunk. Over them he buttoned a cuff-frayed and graying black cassock with its faint stink of him, waisted it with a hand-wide black cincture, snapped on a starched white Roman collar, and laced on his ankle-high black walking shoes. And then he dipped a horsehair toothbrush in a yellow box of bicarbonate of soda and assaulted his grimace in the spotted mirror hanging over the washstand, amusing himself by rhyming: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerardus M. Hopkins, S.J.")]), _vm._v(" / "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Auditor Theologiae./Here at Saint Beuno’s./Far too long, my nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Because December 8th was the Catholic solemnity of the Immaculate Conception of Mary, classes were canceled and the forty-one seminarians and ten professors at Saint Beuno’s School of Theology could while away the wide hours of morning and afternoon in holy obedience to hobbies and exercise in the glens and pastures of northern Wales.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eight played football on a slanted pitch, in jerseys and cardigans, their hands shoved deep into their woolen trouser pockets due to the rawness of wind and cold. Bill Dubberley and three others went down to the green River Elwy with rods and reels “to do,” as they announced at breakfast, “evil things to the fish.” A professor of ecclesiology strolled outside in his derby, overcoat, cassock, and calabash pipe, reading his breviary. Edward Reeve stayed inside and tried to teach parlor tricks to his snappish pet ferret with white crumbles of Yorkshire cheese. Three Brothers worked noisily in the kitchen, preparing the one p.m. dinner, as Frank Scoles, a newly ordained priest, baked an angel food cake. Clement Barraud scowled with the world’s own confusion as he read a gift copy of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Temptation of Saint Anthony")]), _vm._v(", by Gustave Flaubert, that the Rector had given him permission to keep. A pianist of exemplary patience was in the sacristy practicing Johann Sebastian Bach’s minuets on the grunting harmonium there. And Hopkins invited with him on a ramble to the city of Saint Asaph, three miles north, Joseph Rickaby, a very smart runt with an M.A. in philosophy who was the son of the butler to Lord Herries, and Albert Wagner, the “t” not sounded, a shy, smiling man from the Province of Lyons in France whose seniority in the Society of Jesus would cause him to be the first in their second-year class to be ordained a priest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Strolling to Saint Asaph, Rickaby mentioned a variety of writing projects that he wanted to tackle once examinations were concluded and was particularly keen on getting started on an index to the works of John Henry Newman. Wagner was a sterling linguist who said his post-examination project was to learn Coptic as a prelude to the study of Egyptian. Whereas Hopkins claimed he had no grand ambitions for the holidays; that the pursuit of holiness was enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rickaby said, “But I’m scandalized you would lie so flagrantly on one of Our Lady’s feasts! You’re a hobbyist if I’ve ever seen one. Always learning Welsh, hunting etymologies, sketching cloud formations…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“…enduring contradictions.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But hobbies are excellent things!” Rickaby said. “A project is like a sponge that sucks up all your attention and keeps you from brooding over whatever displeases you. Some overriding interest is the great preservative against quarreling and mutinous thoughts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins smiled. “I’m having a mutinous thought just now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rickaby turned to Wagner. “Restless as a weevil, our gentle Hop is. Don’t think he won’t fill his hours with something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The theologians carried sandwiches but no coins, and the city of Saint Asaph was without great fascination, so they simply visited the once-Catholic cathedral to see the restoration of the intricately wood-carved choir stalls that Oliver Cromwell tried to destroy by using them as cattle pens. And then the three walked back to Saint Beuno’s in the sifting snow, edifying each other by praying the five glorious mysteries of the Rosary on the way, and then goading the scholastics fishing the Elwy until Bill Dubberley caught a trout and fell waist deep in the river while hauling it in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins shouted, “Has it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dampened")]), _vm._v(" your enthusiasm, Bill?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A jubilant Dubberley hoisted his trout.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To his father, Hopkins would write that on the Elwy “there is good fishing for those who do not see that after bad fishing the next worst thing is good fishing.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("At six the whole school went to the main chapel in their cassocks and birettas for the singing of Vespers and for the Benediction and Exposition of the Blessed Sacrament, Rector James Jones, the celebrant, incensing the congregation and the Host, leading them in the Eucharistic hymn "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Tantum Ergo,”")]), _vm._v(" and blessing them with the ceremonial monstrance, in which the Host seemed the core of golden rays of sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then, to honor the solemnity at the evening supper, a quart decanter of claret was on each refectory table in addition to the usual pitcher of ale. Conversation in English was allowed, so there was a good deal of laughter, and the priests and scholastics lingered until Brother Fogherty shouted, “Are you all still dithering here?” and shooed them out so he could stack the Windsor chairs and wet-mop the oak floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Exiting the room, Reverend Josef Floeck of Germany, a professor of dogmatic theology who had recently been ostracized with other Jesuits by Otto von Bismarck, asked Hopkins, “Haff you read about za "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" und za fife German nuns?”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Hopkins went to a scholastics’ recreation room that was as large and high-ceilinged as some village churches, but furnished like a run-down gentlemen’s club, with a variety of Irish Georgian wingback chairs surrounding a great fireplace, two walnut secretaries for writing, each with something wrong with it, hand-me-down upholstered sofas and library chairs, a green felt billiards table, and card tables for whist or the game that Americans called checkers, the English called draughts, and Albert Wagner called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("le jeu plaisant de dames")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wednesday morning’s London "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times")]), _vm._v(" was still cool from its afternoon journey from Rhyl as Hopkins carried it to a sofa underneath a sconced gas retort. The front page, as always, was filled with three-and four-line advertisements for Newcastle, Silkstone, or Wall’s-End coal, Bailey’s elastic stockings, ladies’ abdominal belts, Pulvermacher’s Patent Galvanic Chain Bands, Antakos corn plasters, Iceland Liniment for chilblains, and “Want Places” appeals from wet nurses, scullery maids, and cooks, each willing to supply testimonials about their skills and finer qualities. Other pages reported the meteorological data for the month of November, and news from Berlin about Britain’s shrewd purchase of shares in the Suez Canal. Writing from Rome was an “occasional correspondent” who noted Italy’s sarcastic response to the contempt for Catholicism of Britain’s former Prime Minister, William Gladstone, who’d written that the Jesuits in particular were “the deadliest foes that mental and moral liberty have ever known.” Old news for Hopkins, and he lost interest in the article after the first paragraph. But on page 5, next to a dull column on President Ulysses S. Grant’s address to the Congress of the United States, was a headline, "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LOSS OF THE DEUTSCHLAND")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wrecks and Casualties” was a regular department in each issue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v("—sixteen accidents were recorded on December 8th—and among the Victorians there was a general fascination with tales of great tragedies at sea. But more than that, Hopkins’s father was the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Handbook of Average")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Manual of Marine Insurance")]), _vm._v(", both standard reference books for negotiating, averaging, and adjusting the liabilities to insurance underwriters of cargo losses and shipwrecks, so Hopkins grew up in a world wet with marine accidents and was especially attentive to them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In this instance, telegrams from Sheerness, Harwich, and the Lords of the Admiralty were pieced together with a Press Association report, each duplicating or elaborating on the news that the North German Lloyd steamer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(", heading to New York from the port of Bremen in a heavy gale, ran aground on a sandbank near the mouth of the Thames River at five in the morning on December 6th. “She afterwards knocked over the sand, and is now lying in 4"), _c('sup', [_vm._v("1")]), _vm._v("/2 fathoms, apparently broken amidships. Estimated number of passengers and crew lost, 50; remainder landed and under the care of the German Consul at Harwich.” Steerage passengers who were missing were not listed, but among those lost from the first-or second-class cabins were five exiled nuns, whose misspelled names were given as “Barbara Hilkenschmidt, Henrico Tassbander, Lorbela Reenkober, Aurea Radjura, and Brigella Dambard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frederick Hopkins, a medical doctor who had entered the Novitiate with Gerard in 1868, and whose suave manner had earned him the nickname of “the genteel Hop,” sat on the sofa cushion next to his and glanced at the page. “Are you reading about the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very sad, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thirty-three years later, Frederick would become the Bishop of Honduras, and he would drown in 1923, at age eighty-nine, when the overloaded paddleboat he was on sank in eighteen feet of water. But now the doctor said in his soothing voice, “Well, the sea can be very wild.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Edward Reeve was playing billiards with Cyprian Splaine of Liverpool, a swashbuckling scholastic who was good at whatever game he took on. Reeve tried to distract him by saying, “I can still see our evening menu on your beard, Sib.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without looking up from his shot, Splaine said, “The front of your cassock displays what we ate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("last week")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was general laughter, and as Hopkins got up from the sofa, he wryly misquoted Tertullian’s praise for Christian love. “Look,” Hopkins said, “how they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shove")]), _vm._v(" one another.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Walking to the main chapel, Hopkins heard a sneering wind outside and he thought of it as sea-roaring "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" weather, carried there as if by the Royal Mail. But in the darkened chapel it was so silent he could hear the faint sweet sibilance as knuckling flames consumed the wicks of the votive candles. He genuflected and sank onto a kneeler six pews back from Christ in the tabernacle and noticed off to his right Brother McKeon saying his Rosary. Reverend William Hayden, an Englishman just three months a priest, was in front of McKeon and tilting toward the ruby glow of the sanctuary light in order to read his breviary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Casting back on his day in his nightly examination of conscience, Hopkins accused himself of a snorting, sour, unspiritual tone to some of his conversations, prayed for those who’d died, were injured, or lost loved ones in the shipwreck, but thanked God for the beauties and contrarities of nature, the tonic of outdoor exercise, and the cheer and solace of his Jesuit brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Thursday it was colder and again snowing, and there were, as usual on Thursdays, no classes, but Hopkins still rose at five-thirty so he could meditate for an hour before the school’s seven o’clock Mass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sitting with Jerome’s Latin Vulgate version of the Bible in his room, Hopkins made the sign of the cross and whispered, “Lord God, grant me the grace that all my intentions, actions, and operations may be directed purely to the service and praise of Thy Divine Majesty.” And then he asked for the grace he wanted, which was to surrender his own predilections in order to become a perfect instrument of God’s holy will, and to give up whatever was getting in the way of the pleasing sacrifice of Abel: the firstlings of his flock. Reading over the fourth chapter of Genesis, Hopkins agonized that he’d too frequently been like Cain, scrounging fruit fallen onto the ground and presenting that as his lame offering to God and then, justly ignored, and with hurt feelings and envy, slaying a brother with his curt judgments and tart wit. Language his bloody knife. And what were his firstlings? Loyalty, yes, and discipline, education, talent. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("These I offer Thee")]), _vm._v(", Hopkins prayed. But then for the next thirty minutes of meditation there was nothing like a striking insight or a welling up of emotion. Rather than the Scripture passage, his reveries continued hiving around some verses of Milton’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Samson Agonistes")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Retiring from the popular noise, I seek")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This unfrequented place to find some ease,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Ease to the body some, none to the mind")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("From restless thoughts, that like a deadly swarm")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Of Hornets arm’d, no sooner found alone,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("But rush upon me thronging, and present")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Times past, what once I was, and what am now.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then he saw it was time for Mass.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Cyprian Splaine recruited Hopkins for a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("peripatetic")]), _vm._v(", as he called it, to Denbigh. Splaine was the big, bluff, confident, manly sort that Hopkins found attractive, and Hopkins was vigilant in his vow of chastity, so he obeyed the Rector’s rule of “companies” on such hikes—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nunquam duo, semper tres")]), _vm._v(": never two, always three—a requirement meant to discourage conflicts or particular friendships. Inveigling Billy Splaine, Cyprian’s kid brother, to join them, Cyprian advertised Denbigh as a “picturesque town,” and Hopkins joked that because of its popularity with tourists Denbigh was even more a “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("taking")]), _vm._v(" pictures-esque town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they were slogging southward in their black suits and overcoats on a highway now inches deep with snow, Billy gave an excited account of Captain Matthew Webb’s heroic suffering during his twenty-two-hour swim of the English Channel, from Dover to Calais, the first to accomplish it, his body slimed with porpoise grease to fend off the murderous cold, his only nourishment cod-liver oil, brandy, beef tea, and strong old ale poured through funnels by friends in dinghies alongside him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cyprian smirked. “And now shall we expect you to challenge his speed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Billy replied with solemnity, “I’ll have to request permission from Father Rector.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quoting from Shakespeare’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Julius Caesar")]), _vm._v(", Hopkins recited: “‘As he was fortunate, I rejoice at it; as he was valiant, I honour him: but, as he was ambitious, I slew him.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cyprian scowled as he interpreted his friend’s meaning and asked, “Are you still studying the Welsh language, Gerard?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rarely,” Hopkins said, and then confided to Billy, “I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" consult Father Rector about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, the Governor’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wants us focused on the one holy thing,” Cyprian said. “Wants uniformity.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The limekiln under a quarried cliff sent out yellow smoke that dimmed the distance and made the stack of Denbigh Hill a dead, mealy gray, but the sun was sparkling through gaps in the raveled clouds and Hopkins, who noticed architecture, noticed aloud how the castle ruins that crowned the hill were “punched out in bright breaks and eyelets of daylight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cyprian was, as always, amused by him. “Sees things,” he stage-whispered to his kid brother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Entrance into the castle required a penny admission charge and they’d scrounged no money from Father Minister, so they instead ate sack lunches by a stone stile under a snowcapped outer wall overgrown with ivy, bramble, and some graceful herb with glossy lush green sprays that were something like celery. Billy had forgotten the Latin for celery, and Cyprian, the finest Hebrew and Latin scholar in the school, took only seconds to answer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Apium graveolens,”")]), _vm._v(" and was surprised by their laughter, saying, as Hopkins sat, “Surely a prize student of Jowett knows such things?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jowett?” Billy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins told him his tutor at Oxford was Reverend Benjamin Jowett, an Anglican theologian who had strayed so near heresy that he largely confined his teaching to Plato and Greek philosophy. Jowett was also an eminent classical scholar who had never visited Athens or Rome. In fact, he seldom left the Oxford campus, staying in touch with those he formerly taught with continual letters of inquiry. “Of him it was written,” Hopkins said, “‘First come I. My name is Jowett. There is no knowledge but I know it. I am a tutor in this college. What I don’t know isn’t knowledge.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Billy smiled. “And you’re a chip off the old block, aren’t you, Hop?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, but I have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gaping")]), _vm._v(" holes in my erudition.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Cyprian told his brother, “You just need to spelunk to find them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hiking back to Saint Beuno’s, Hopkins taught them some Welsh: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("afal")]), _vm._v(" was apple; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aderyn")]), _vm._v(", bird; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("llaeth")]), _vm._v(", milk; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pysgodyn")]), _vm._v(", fish. Crow, they knew, was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bran")]), _vm._v(", for “crow” was Welsh slang for a Jesuit in his black cassock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then they saw a vast multitude of starlings making, as Hopkins put it, “an unspeakable jangle.” The starlings would settle in a tree, then, stirring and cheering one another, choose another tree in the row to light upon, rising up again at some interior signal. Singularities forgotten. To Hopkins they seemed a cloud of snuff shaken from a wig, many of them in one phase at once, full of zest and delight at hearing each other’s cries, all veering black flakes hurling around until they decided in unison to stand quietly in the field. Like his classmates waiting lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are they all scholastics, do you think?” Hopkins asked, and Cyprian guffawed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Had I a gun, it would rain meat,” Billy said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And his older brother instructed Hopkins, “Remember your steel umbrella when you next visit us in Liverpool.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Raisin cakes and Earl Grey tea were served in the gymnasium-sized refectory at five, and then Hopkins went to the scholastics’ recreation room to see if "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" was available. It was. And he took it with him as he joined a “circle” of Joe Rickaby, Bill Dubberley, and Clement Barraud for an examination review in moral theology. Sydney Smith, an architect and the convert son of an Anglican clergyman, perused his notebook and reminded them, “We have seen that a passion—whether "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("commotio, permotio, concitatio")]), _vm._v(", or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("perturbatio")]), _vm._v("—is nothing other than a movement of the soul caused by the sensate apprehension of a particular good or evil object and accompanied by an organic mutation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smith continued with his class notes, but Hopkins instead read the six columns on page 6 that were dedicated to “The Loss of the Deutschland.” Readers were reminded that just seven months earlier the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schiller")]), _vm._v(", another German transatlantic liner, wrecked on the Scilly Isles, southwest of Land’s End, England, and three hundred twelve lives were lost, “a coincidence of calamities which at present there is no reason for thinking other than fortuitous.” The owners of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(", the North German Lloyd Company, were their own insurers, up to now a sound economic decision, for there had not been a passenger lost at sea in their fleet since the initial voyage in 1856. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liverpool Underwriters’ Book of Iron Vessels")]), _vm._v(" was consulted for the ship’s precise length, depth, width, and tonnage. The writer presumed the captain of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" wanted to avoid the shoals of the Dutch coast with a more westerly course that instead sent the steamship too close to the shoals of the Thames estuary. There was just one propeller, and that was lost and unserviceable soon after the ship struck at five on the morning of December 6th.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When at high tide that night there was flooding in steerage and the upper decks, the passengers were ordered up onto the masts and spars. “In that cold and terrible night between Monday and Tuesday,” the correspondent wrote, “many unhappy persons must have lost their hold upon the rigging and fallen numbed into the sea.” Quartermaster August Bock’s sail-aided lifeboat washed ashore near the Royal Navy barracks at Sheerness, and he was being skillfully rendered treatment by Staff Surgeon Flanagan, while the cold-blackened remains of his two boat mates awaited undertaking in the Duke of Clarence Hotel. A long list of survivors and “missing, presumed dead” was published. It was noted that the sea-swollen corpse of Adolf Forster, whose ticket number was 52, had just floated ashore at Margate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were no photographs, of course, so one’s imagination took over, and Hopkins found himself getting queasy. But that was all that he had time to skim anyway, for that Thursday night he needed to swot, as they’d said at Oxford, the tiring textbooks for five hour-long lectures the next day, all conducted in Latin. Moral theology was the most technical subject, and Hopkins used up all the coals in his scuttle scrutinizing a treatise on Contracts and memorizing the meanings of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("emphyteusis")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("laudemium")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mohatra")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("antichresis")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hypotheca")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("servitus activa et passiva")]), _vm._v("—which he would have guessed concerned slavery, but instead concerned easement to properties.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("His night’s sleep was tangled up not by Contracts but by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" reports and the singsong and hammer-and-anvil beats of Longfellow’s unjustifiably famous poem “The Wreck of the Hesperus” and its stanzas:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("She struck where the white and fleecy waves")]), _vm._v(" "), _c('p', {
    staticClass: "extractText1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Looked soft as carded wool,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("But the cruel rocks, they gored her side")]), _vm._v(" "), _c('p', {
    staticClass: "extractText1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Like the horns of an angry bull.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Her rattling shrouds, all sheathed in ice,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("With the masts went by the board;")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Like a vessel of glass, she stove and sank,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Ho! Ho! the breakers roared!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Waking on Friday morning with its stupefying awfulness still Ho! Hoing! in his mind, Hopkins was depressed that the stanzas had so deftly found lodging in his memory. “The Wreck of the Hesperus” was the sort of cloying poetry that seagoing tragedies generally inspired in England and America: their sentiments trite, their rhymes forced, their syllabic counts as regular as the ticking of a hallway clock. Whereas he had long had haunting his ear the echo of a new rhythm that would re-create the native and natural stresses of speech.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the scruples to which he was prey caused Hopkins to consider the worldly pursuit of poetry writing in conflict with his vocation to the priesthood. Just before entering the Society of Jesus in 1868, Hopkins resolved to pen no more verse unless his religious superiors requested it, and in a theatrical act of renunciation he incinerated some copies of his Oxford poems in a secret ceremony that he inconspicuously noted in his journal simply as “the slaughter of the innocents.” And that act of renunciation was confirmed for him when, as a novice Jesuit, he was urged to relinquish “disordered attachments” that would impede his freedom and availability for a variety of ministries as well as tempt him to the sin of pride. Since then he’d written only the slightest kinds of poetry: joshing doggerel to entertain at picnics or Latin greeting-card verse for visiting dignitaries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And yet…there was always an interior and hard-to-quell “and yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("His floor swept with sawdust, his clothing on hooks, his gray blankets as taut on his bed as a cavalry sergeant’s, Hopkins walked out into a hallway that was wide as a road and wedged his door open in the Jesuit display of owning nothing and having nothing to hide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brother Tom Fagan was hurrying down to the kitchen scullery, but winked at him in the Great Silence of Friday’s pre-dawn and yanked his forelock like an earl’s footman who lacked a cap. Smiling and slightly waving a hand in a “Carry on” gesture, Hopkins headed to the Saint Agnes oratory, and just for the childishness of it, he skipped down the hallway, watching the skirt of his cassock flounce.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the oratory, Hopkins vested himself in a fresh white surplice with a hem and half-sleeves that were as lacy as the doilies his mother put under desserts, and then he lit two candles that flanked the tabernacle on the altar, retrieved the crystal cruets of water and wine from the sacristy, and ribboned the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missale Romanum")]), _vm._v(" for the Mass of December 10th.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Bernhard Tepe was late. Waiting for him, Hopkins studied a framed commemorative placard that featured the photographs of five priests murdered by Communards in May 1871 after Paris fell in the Franco-Prussian War. The five had nothing to do with the defeat, but the Church with its lordly hierarchy and affiliations with the educated elites was perceived as an anachronism that was resistant to revolution, and so Pierre Olivaint, Leon Ducoudray, Alexis Clerc, Jean Caubert, and Anatole de Bengy, all Reverend Fathers of the Society of Jesus, were executed by gunfire "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“en haine de la Foi catholique,”")]), _vm._v(" in hatred of the Catholic faith.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a persecution that the Society of Jesus was now accustomed to, for in 1868 the Jesuits were expelled from Spain, and in 1870 the Jesuit curia was expelled from Rome as the papal states were annexed by King Victor Emmanuel II. The Jesuit Superior General, Pierre-Jean Beckx, was now managing the affairs of the Society from Florence. In northern Europe, Chancellor Otto von Bismarck orchestrated the unification of Prussia, Bavaria, Saxony, Württemberg, and twenty other states into the Second Reich of Germany, and originated a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kulturkampf")]), _vm._v(", or cultural struggle, that was intended to quash the political power of the country’s Catholic minority, which Bismarck loathed for being more loyal to the papacy than to the Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins was in philosophy studies at Stonyhurst in 1872 when the Reichstag gave the government license to ostracize the Society of Jesus, and the first contingent of exiled German Jesuits arrived in England. And now their Rhineland Theologate was located in Ditton Hall, between Manchester and Liverpool. In May 1873, Culture Minister Adalbert Falk instituted laws giving the Reich control of Catholic education, making civil marriages obligatory and ending all financial aid to the Catholic Church while continuing it for Protestant institutions. And just seven months ago another series of “May Laws” were decreed, excluding from the territories of the Prussian state all Catholic religious orders not involved in the needed job of nursing, and consigning each congregation’s properties to the management of a board of trustees selected by the government. Hopkins felt certain the five German nuns who had lost their lives on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" were emigrating from their country because of the Falk Laws.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Tepe hurried into the oratory, wincing a smile of apology over his tardiness and greeting him with the Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Salve, Frater.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Et tu, Pater.”")]), _vm._v(" And you, Father.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Bernhard Tepe of Germany was teaching, like Reverend Josef Floeck, dogmatic theology to the newly ordained fourth-year students. Reverend Henrico Legnani oversaw the course of study for those who were not yet priests. And Reverend Emilio Perini of Italy would handle courses in Sacred Scripture at Saint Beuno’s for thirteen years. The upheavals on the Continent had contributed the majority of the professors in the British province’s only school of theology. Hopkins recalled the curse of Cain: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thou shalt be a fugitive and vagabond on the earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Tepe caped his shoulders with a white amice and tied its long strings around his waist. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Tempestas frigidus,”")]), _vm._v(" he said. Cold weather.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Ita est,”")]), _vm._v(" Hopkins said. So it is.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The north wind seemed to have teeth as Hopkins used his Friday hour of recreation to scan the snow-covered geography from the heights of the steep hill named Moel y Parch. To the southwest, Mount Snowdon and its children peaks in the range looked like a stack of rugged white flint, streaked with snow, in many places chiseled and channeled. The hedged and stone-fenced farmlands of the vale of Clwyd to the west were the stitched white squares in a shirred quilt that went all the way to the gray ribbon of the Irish Sea and the town of Rhyl, its carnival and silted promenade shut up for the winter. Eastward some twenty miles was Liverpool, its soot and smoke and office buildings no more than gray gorse from that distance. The air smelled cleansed; the leaden sky was roped with cloud; a blue bloom seemed to have spread upon the distant south, enclosed by a basin of hills. And again he felt the charm and instress of Wales.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned and saw one black-faced sheep warily staring, as if the seminarian were haunting it, while other sheep dully watched him as they monotonously chewed straw. “Shepherd” in Latin was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pastor")]), _vm._v(", and he smiled as he thought of himself as twice or thrice pastoral there among the animals, in the graciousness and serenity of a school of theology. Worried at his noticing, the black-faced sheep headed away from him, rousing the others into a hesitant trot, and Hopkins grinned at thinking it another "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kulturkampf")]), _vm._v(" as he went down to Saint Beuno’s for classes in canon law and Hebrew.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Saturday evening, Rector James Jones strolled into the scholastics’ recreation room—an innovation of his governance since the groups of ten ordained professors, seven lay Brothers, and forty-one theologians each had separate dinner tables, housing areas, and recreation rooms in the great three-story mansion, and some considered incursions an insulting act of trespass. But “Father Rector,” as he was called, was a manly, rattling, genial, ever-courteous man from County Sligo, Ireland, a shrewd, scientific professor of moral theology who’d studied at the English College in Rome, served as a Superior in British Guiana and Jamaica, and published two scholarly books on the Athanasian creed, yet welcomed contradiction in class and the nickname of “the Governor,” delighted in jokes and singing, and so worried about the seminarians’ health that he stayed at their bedsides when they were ill, tipping into their mouths his mother’s cure-all of hot milk, brandy, and a beaten egg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rector Jones joked with the Irish trio of Kelly, Morrogh, and Gavin, and with their laughter left the three and jested in his scratchy Latinity with the scholastics Victor Baudot and Sebastian Sircom, who’d been exiled from France. And then he wandered over to the great fireplace and the half-circle of Irish Georgian wingback chairs where Hopkins was alone with his stare fastened on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would it be a discourtesy if I joined you?” the Rector asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins lifted his head and smiled at his fair, tall Superior. “Not at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jones selected the wingback chair next to his. “Don’t let me interfere with your reading.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins held open the newspaper so Jones could see the multiple articles on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" shipwreck. Hopkins told him, “The nuns have been laid out for viewing in the Convent of Jesus and Mary near Stratford. I would guess they’ll be interred in Saint Patrick’s cemetery, just a mile from where I was born.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Rector scanned the headlines. “I heard about it, but haven’t kept up.” Elm logs in the fireplace sang and popped, spewing sparks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins read aloud: “‘At two p.m., Captain Brickenstein, knowing that with the rising tide the ship would be waterlogged, ordered all the passengers to come on deck. Danger levels class distinctions, and steerage and first-class passengers were by this time together in the after saloon and cabins. Most of them obeyed the summons at once; others lingered below till it was too late; some of the ill, weak, despairing of life even on deck, resolved to stay in their cabins and meet death without any further struggle to evade it.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh dear,” Jones said. “Saddening.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins continued. “‘After three a.m. on Tuesday morning a scene of horror was witnessed. Some passengers clustered for safety within or upon the wheelhouse, and on the top of other slight structures on deck. Most of the crew and many of the emigrants went into the rigging, where they were safe enough as long as they could maintain their hold. But the intense cold and long exposure told a tale.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cold wind, icy seas,” said Jones. “Horrible in combination.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘The purser of the ship, though a strong man, relaxed his grasp, and fell into the sea. Women and children and men were one by one swept away from their shelters on the deck.’ And here it’s quite moving, Father: ‘Five German nuns, whose bodies are now in the dead-house here, clasped hands and were drowned together, the chief sister, a gaunt woman six feet high, calling out loud and often “O Christ, come quickly!” till the end came. The shrieks and sobbing of women and children are described by the survivors as agonizing.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jones sighed, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Requiescant in pace,”")]), _vm._v(" but then glanced over at his underling. Hopkins was so greatly affected by the account that he was close to tears.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jones kindly considered him and said, “Perhaps someone should write a poem on the subject.” And then the Rector gently patted Hopkins’s forearm and got up to heartily greet some theologians who’d just entered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopkins touched a handkerchief to each eye and left "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" for others on a gleaming library table as he walked out. Although he’d at first intended to visit the main chapel for his nightly prayers in the presence of the Blessed Sacrament, his thoughts were racing, and in the rapture of inspiration he hurried up the stairs to his room in “The Mansions.” And though his “hand was out at first,” as he later admitted, Hopkins managed by midnight to pen eight lines:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "11%"
    }
  }, [_vm._v("On Saturday sailed from Bremen,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "8%"
    }
  }, [_vm._v("American-outward-bound,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Take settler and seaman, tell men with women,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "8%"
    }
  }, [_vm._v("Two hundred souls in the round—")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("O Father, not under thy feathers nor ever as guessing")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("The goal was a shoal, of a fourth the doom to be drowned;")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "8%"
    }
  }, [_vm._v("Yet did the dark side of the bay of thy blessing")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_vm._v("Not vault them, the millions of rounds of thy mercy not reeve even them in?")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57fb2414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780374150976_ch01.vue
// module id = 84
// module chunks = 0